import React, { useEffect, useState } from "react";
import Header from "../../component/users/Header";
import { useSelector } from "react-redux";
import {
  FormControl,
  InputLabel,
  TextField,
  Button,
  Backdrop,
  CircularProgress,
  Box,
  Typography,
  Checkbox,
  Link,
  FormHelperText,
  FormControlLabel,
  InputAdornment,
  IconButton,
  Container,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import HomeSkeleton from "../../component/users/Home/Skeleton";
import Footer from "../../component/users/Footer";
import { Add } from "@mui/icons-material";
// import AddTournamentForm from "../../component/users/AddTournament/AddTournamentForm";
import AddClubForm from "../../component/users/AddClub/AddTournamentForm";
import LoaderLayout from "../../component/users/LoaderLayout";
import LoaderLayout2 from "../../component/users/LoaderLayout2";
// import { getTournament } from "../../api/getTournament";
import { getClub } from "../../api/getClub";
import { toast } from "react-toastify";

const AddGoal = () => {
  const userData = useSelector((state) => state.loggedUser.user);
  const user = useSelector((state) => state.user.loading);

  const urlparam = useParams();
  const token = useSelector((state) => state.auth.token);
  const [editTournamentLoading, setEditTournamentLoading] = useState(true);
  const [editTournamentDetails, setEditTournamentDetails] = useState(null);
  const navigate = useNavigate();

  const fetchClubDetails = async (id) => {
    try {
      const response = await getClub(id, token);
      if (response.success) {
        setEditTournamentDetails(response.data);
        setEditTournamentLoading(false);
      } else {
        toast.error(response.message);
        navigate("/");
      }
    } catch (error) {
      toast.error("error while getting goal data");
      setEditTournamentLoading(false);
      navigate("/");
    }
  };

  useEffect(() => {

    if (urlparam.id) {
      fetchClubDetails(urlparam.id);
    } else {
      setEditTournamentLoading(false);
      toast.error("no id found of goal");
    }
  }, [urlparam.id]);

  return (
    <>
      <Header />

      {user ? (
        <LoaderLayout />
      ) : !editTournamentLoading ? (
        <Box className="userLayout addGoal">
          <Container
            disableGutters={true}
            maxWidth="lg"
            sx={{ background: "#242743" }}
          >
            <Box className="addGoal-wrapper addTournament-wrapper">
              <AddClubForm editTournamentDetails={editTournamentDetails} />
            </Box>
          </Container>
          <Footer />
        </Box>
      ) : (
        <LoaderLayout2 />
      )}
    </>
  );
};

export default AddGoal;
